import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "cart-item-additional"
};
const _hoisted_2 = {
  key: 0,
  class: "cart-item-additional__content-no-collapse"
};
const _hoisted_3 = {
  class: "cart-item-additional__col1-no-collapse"
};
const _hoisted_4 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_5 = {
  class: "cart-item-additional__col2-no-collapse"
};
const _hoisted_6 = {
  key: 1,
  class: "cart-item-additional__content-no-collapse"
};
const _hoisted_7 = {
  key: 0,
  style: {
    'grid-row': 1
  },
  class: "cart-item-additional__col1-no-collapse cart-item-additional__item-label"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", {
  style: {
    'grid-row': 1
  },
  class: "cart-item-additional__col2-no-collapse"
}, null, -1);
const _hoisted_9 = {
  class: "cart-item-additional__content"
};
const _hoisted_10 = {
  class: "cart-item-additional__col1"
};
const _hoisted_11 = {
  key: 0,
  class: "cart-item-additional__item"
};
const _hoisted_12 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_13 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_14 = {
  key: 1,
  class: "cart-item-additional__item"
};
const _hoisted_15 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_16 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_17 = {
  key: 2,
  class: "cart-item-additional__item"
};
const _hoisted_18 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_19 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_20 = {
  key: 3,
  class: "cart-item-additional__item"
};
const _hoisted_21 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_22 = {
  class: "cart-item-additional__item-value"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  class: "cart-item-additional__col2"
};
const _hoisted_25 = {
  key: 0,
  class: "cart-item-additional__item"
};
const _hoisted_26 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_27 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1,
  class: "cart-item-additional__item"
};
const _hoisted_30 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_31 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_32 = {
  key: 2,
  class: "cart-item-additional__item"
};
const _hoisted_33 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_34 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_35 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_36 = {
  key: 4,
  class: "cart-item-additional__item"
};
const _hoisted_37 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_38 = {
  class: "cart-item-additional__item-value notranslate"
};
const _hoisted_39 = {
  class: "cart-item-additional__item-label"
};
const _hoisted_40 = {
  class: "material-label-wrapper"
};
const _hoisted_41 = {
  class: "material-label-text notranslate"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "separator"
}, " - ", -1);
const _hoisted_43 = {
  class: "material-label-wrapper"
};
const _hoisted_44 = {
  class: "material-label-text notranslate"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = _resolveComponent("Tooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.isCheckout && $options.deliveryTolerance ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString($options.getLabel('cart.page.line.item.deliveryTolerance')), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString($options.deliveryTolerance), 1)])])])) : _createCommentVNode("", true), $props.isCheckout && $props.item?.orderSurcharges?.length > 0 && $options.surchargeDiscountLabels?.length > 0 && $options.surchargeDiscountValues?.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [$options.isSurchargeOrDiscount ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($options.getLabel('surcharge.discount.Title')), 1)) : _createCommentVNode("", true), _hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.surchargeDiscountLabels, (label, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: "cart-item-additional__col1-no-collapse",
      style: _normalizeStyle({
        'grid-row': index + 2,
        'order': index
      })
    }, _toDisplayString(label), 5);
  }), 256)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.surchargeDiscountValues, (value, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: "cart-item-additional__col2-no-collapse",
      style: _normalizeStyle({
        'grid-row': index + 2,
        'order': index
      })
    }, _toDisplayString(value), 5);
  }), 256)), $props.shipToCountry == 'BR' ? (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: "cart-item-additional__col2-no-collapse",
    style: _normalizeStyle({
      'order': $options.surchargeDiscountLabels.length + 1
    })
  }, [_createElementVNode("b", null, _toDisplayString($options.getLabel('brazil.tax.disclaimer.message')), 1)], 4)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$props.isCheckout && $props.item.paymentTermDescription ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString($options.getLabel('payment.terms.Title')), 1), _createElementVNode("p", _hoisted_13, _toDisplayString($props.item.paymentTermDescription), 1)])) : _createCommentVNode("", true), $props.item.incoTerms ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString($options.getLabel('inco.terms')), 1), _createElementVNode("p", _hoisted_16, _toDisplayString($props.item.incoTerms), 1)])) : _createCommentVNode("", true), $props.item.shippedFrom && !$props.item.isVirtualPlant ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString($options.getLabel('cart.page.line.item.shippedFrom')), 1), _createElementVNode("p", _hoisted_19, _toDisplayString($props.item.shippedFrom), 1)])) : _createCommentVNode("", true), $props.item.url && ($props.item.orderRules?.displaySiSelectRules || $props.item.orderRules?.displayBundleRules || $props.item.orderRules?.displayStandardRules || $props.item.orderRules?.displaySpecialtyRules) ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString($options.getLabel('cart.page.line.item.rulesApplied')), 1), _createElementVNode("p", _hoisted_22, [_createElementVNode("a", {
    href: $props.item.url,
    target: "_blank"
  }, _toDisplayString($options.getLabel('terms.conditions')), 9, _hoisted_23)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [$props.item.forwardingAgent || $props.item.forwardingAgentAddress?.formattedAddress || $props.item.forwardingAgentAddress?.companyName ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString($options.getLabel('addressBuyer.component.forwardingAgent')), 1), _createElementVNode("p", _hoisted_27, [_createTextVNode(_toDisplayString($props.item.forwardingAgent) + " - ", 1), $props.item.forwardingAgentAddress?.companyName ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString($props.item.forwardingAgentAddress?.companyName) + ", ", 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($props.item.forwardingAgentAddress?.formattedAddress), 1)])])) : _createCommentVNode("", true), $props.item.contractData?.contractNo || $props.item.contractData?.contractName ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString($options.getLabel('cart.page.line.item.cantract')), 1), _createElementVNode("p", _hoisted_31, _toDisplayString($props.item.contractData?.contractNo) + " - " + _toDisplayString($props.item.contractData?.contractName), 1)])) : _createCommentVNode("", true), $props.item.customerSpec1List?.length && $props.item.customerSpec1 !== 'Batch Search Strategy Specification' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString($options.getLabel('customer.component.customer.specification.label1')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.customerSpec1List, (spec, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: "cart-item-additional__item-value notranslate",
      key: index
    }, _toDisplayString(spec), 1);
  }), 128))])) : _createCommentVNode("", true), $props.item.customCharactersDataList?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 3
  }, _renderList($props.item.customCharactersDataList, (color, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "cart-item-additional__item"
    }, [_createElementVNode("span", _hoisted_34, _toDisplayString($options.getLabel('dowcorning.dcc.customercharact.color.code')), 1), _createElementVNode("p", _hoisted_35, _toDisplayString(color.valueCode), 1)]);
  }), 128)) : _createCommentVNode("", true), $props.item.endUserCustomerNumber || $props.item.endUserAddress?.companyName || $props.item.endUserAddress?.formattedAddress ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, _toDisplayString($options.getLabel('cart.page.line.item.enduser')), 1), _createElementVNode("p", _hoisted_38, _toDisplayString($props.item.endUserCustomerNumber) + " - " + _toDisplayString($props.item.endUserAddress?.companyName) + " " + _toDisplayString($props.item.endUserAddress?.formattedAddress), 1)])) : _createCommentVNode("", true), $props.item.kitComponents?.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 5
  }, [_createElementVNode("span", _hoisted_39, _toDisplayString($options.getLabel('components.included')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.kitComponents, (component, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "each-material"
    }, [_createElementVNode("span", _hoisted_40, [_createElementVNode("span", _hoisted_41, _toDisplayString($options.materialNumber(component)), 1), component.myPartNumber ? (_openBlock(), _createBlock(_component_Tooltip, {
      key: 0,
      notranslate: true,
      passedText: $options.materialNumberInfoIText(component)
    }, null, 8, ["passedText"])) : _createCommentVNode("", true)]), _hoisted_42, _createElementVNode("span", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString($options.materialDescription(component)), 1), component.myPartDescription ? (_openBlock(), _createBlock(_component_Tooltip, {
      key: 0,
      notranslate: true,
      passedText: component.materialDescription
    }, null, 8, ["passedText"])) : _createCommentVNode("", true)])]);
  }), 128))], 64)) : _createCommentVNode("", true)])])]);
}